import {Component, Inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {AppService} from 'app/services/app.service';
import { DatasetActionContainerService } from '../../services/dataset-action-container.service';
import { DatasetService } from '../../services/dataset.service';
import { FormViewerComponent } from 'app/main/components/form-viewer/form-viewer.component';
import formConfig from './form.config';


@Component({
    selector: 'add-booking-participants-dialog',
    templateUrl: 'dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddBookingParticipantsDialogComponent implements OnDestroy, OnInit {

	loading = false;
	protected _unsubscribeAll: Subject<void>;
	public formConfig = formConfig;
	public datasetACS: DatasetActionContainerService;
	@ViewChild('formViewer', { static: true }) formViewer: FormViewerComponent;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<AddBookingParticipantsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public datasetService: DatasetService
	) {
		this._unsubscribeAll = new Subject();
	}

	ngOnInit(): void{
		this.datasetACS = this.data.datasetACS;
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	onSave(): void {
		this.loading = true;
		const formData = this.formViewer.getFormData();
		if(this.data.postData){
			for (const key in this.data.postData) {
				if (!Object.prototype.hasOwnProperty.call(this.data.postData, key)) continue;
				const value = this.data.postData[key];
				if(formData instanceof FormData){
					formData.set(key, value);
				}else{
					formData[key] = value;
				}
			}
		}
		this.datasetService.post('/dataset/trip_booking_participants/command/generate_participants', formData)
		.subscribe({
			next: () => {
				this.dialogRef.close(true);
			},
			error: response => {
				if(response.error && response.error.errors){
					this.formViewer.setErrors(response.error.errors);
				}
				this.loading = false;
			}
		});
		
	}

	ngOnDestroy(): void{
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
